import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { SharedReduxState } from 'web-shared/reducers/types';
import { getCurrentPack } from 'web-shared/utils/string';

export const ProtectedRoute = ({ children }: React.PropsWithChildren) => {
  const user = useSelector(({ auth }: SharedReduxState) => auth.user);
  const location = useLocation();

  if (user) return children;

  return (
    <Navigate
      to='/sign-in'
      state={{
        from: {
          pack: getCurrentPack(),
          pathname: location.pathname,
          search: location.search,
        },
      }}
      replace
    />
  );
};

export default ProtectedRoute;
